module.exports = __webpack_public_path__ + "static/media/README.4bfb20da.md";